import React from 'react';
import {
  List,
  ListItem,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WorkOrders from './WorkOrders';
import { TaskRecommendation } from '@/__generated__/graphql';
import { AccordionContainer } from './styles';
import { formatDate } from '@/modules/KpiTracker/utils';

type Props = {
  recommendations: TaskRecommendation[];
};

const Recommendations = ({ recommendations }: Props) => {
  return (
    <List>
      {recommendations.map((rec, index) => (
        <ListItem key={index} style={{ display: 'block' }}>
          <Grid container spacing={2} mb={1}>
            <Grid item xs={3}>
              <Typography variant="caption">Recommendation No</Typography>
              <Typography variant="body1">{rec?.recommendationNumber}</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption">Recommendation Type</Typography>
              <Typography variant="body1">{rec.recommendationType}</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption">Status</Typography>
              <Typography variant="body1">{rec.status || 'N/A'}</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption">Status Updated At</Typography>
              <Typography variant="body1">
                {rec.statusUpdatedAt ? formatDate(new Date(Number(rec.statusUpdatedAt))) : 'N/A'}
              </Typography>
            </Grid>
          </Grid>
          {rec?.workOrders.length > 0 && (
            <AccordionContainer>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography fontWeight="bold">{rec?.workOrders.length} Work Order/s</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <WorkOrders workOrders={rec.workOrders} />
              </AccordionDetails>
            </AccordionContainer>
          )}
        </ListItem>
      ))}
    </List>
  );
};

export default Recommendations;
